import { useDynamicModals, useUserWallets } from '@dynamic-labs/sdk-react-core';

import { tw } from '@repo/ui';

import { ConnectedWallet } from './connected-wallet';

export const LinkWallets: React.FC = () => {
  const { setShowLinkNewWalletModal } = useDynamicModals();
  const userWallets = useUserWallets();

  return (
    <div
      className={tw(
        'flex flex-col gap-3 rounded-xl px-3 py-4 text-white md:px-5',
        'bg-[#191819]/80',
      )}
    >
      <div className='flex flex-col'>
        <p className='text-sm font-semibold md:text-base'>CONNECTED WALLETS</p>
      </div>
      <div className='flex flex-col gap-2'>
        {userWallets.length ? (
          userWallets.map((wallet) => (
            <ConnectedWallet
              key={wallet.id}
              wallet={wallet}
            />
          ))
        ) : (
          <>
            <div className='h-[46px] w-full animate-pulse rounded-xl bg-white/10'></div>
            <div className='h-[46px] w-full animate-pulse rounded-xl bg-white/10'></div>
          </>
        )}

        <p
          onClick={() => setShowLinkNewWalletModal(true)}
          className={tw(
            'mt-1 text-sm font-normal text-white/50 underline',
            'pb-0.5 hover:cursor-pointer md:text-base',
          )}
        >
          + CONNECT ANOTHER WALLET
        </p>
      </div>
    </div>
  );
};
